module.exports = __webpack_public_path__ + "static/img/sm_js_11.36d5e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sm/sm_js_11.png
// module id = x79h
// module chunks = 1